{
  "welcome-to" : "Welcome to",
  "copyright": "Copyright",
  "trademarks" : "All trademarks or registered trademarks are property of their respective owners.",
  "menu-profile" : "Profile",
  "menu-logout" : "Logout",
  "menu-home" : "Home",
  "menu-dashboard" : "Dashboard",
  "menu-machines" : "Machines",
  "menu-colaboration" : "Collaboration",
  "menu-administration" : "Administration",
  "menu-machine" : "Machine",
  "menu-list" : "List",
  "menu-service-data" : "Service Data",
  "menu-trash" : "Trash",
  "machine-info" : "Machine info",
  "medium" : "Medium",
  "machine-activity" : "Machine activity",
  "machine-part-info" : "Machine part info",
  "name" : "Name",
  "version" : "Version",
  "owner": "Owner",
  "state" : "State",
  "actions" : "Actions",
  "kind" : "Kind",
  "description" : "Description",
  "size" : "Size",
  "last-write" : "Last write",
  "ver" : "Ver.",
  "restore" : "Restore",
  "when" : "When",
  "type" : "Type",
  "level" : "Level",
  "text" : "Text",
  "tags" : "Tags",
  "part-type" : "Part type",
  "firmware-version" : "Firmware version",
  "model" : "Model",
  "created" : "Created",
  "modified" : "Modified",
  "status" : "Status",
  "loading" : "Loading",
  "fv" : "F.v.",
  "remove" : "Remove",
  "user" : "User",
  "fenix-version" : "Fenix version",
  "service-data-remove-question" : "Are you sure you want to delete this service data?",
  "save-as-duplicate" : "Save as duplicate",
  "upload-file" : "Upload file",
  "restore-machine-data-from-backup" : "Restore machine data from backup",
  "you-want-to-change-owner" : "You want to change the owner?",
  "choose-file" : "Choose file",
  "detail" : "Detail",
  "yes" : "Yes",
  "no" : "No",
  "machine-detail-remove-question" : "Are you sure you want to delete this Machine?",
  "status-auto-update" : "Status auto update",
  "download" : "Download",
  "copy" : "Copy",
  "move" : "Move",
  "change-owner" : "Change owner",
  "new-machine-name" : "New machine name",
  "submit" : "Submit",
  "set-as-current" : "Set as current",
  "checkout" : "Checkout",
  "base-data" : "Base data",
  "part-structure-type" : "Part structure type",
  "owner-id" : "Owner ID",
  "parent-id" : "Parent ID",
  "part-class-type" : "Part class type",
  "errors" : "Errors",
  "generic-device" : "Generic device",
  "device-model" : "Device model",
  "address" : "Address",
  "camera-info" : "Camera info",
  "sensor-model" : "Sensor model",
  "slides-in-view" : "Slides in view",
  "slider-info" : "Slider info",
  "channels" : "Channels",
  "shot-stats-from" : "Shot stats from",
  "shot-stats-to" : "Shot stats to",
  "shot-stats-counter" : "Shot stats counter",
  "shot-stats" : "Shot stats",
  "slider" : "Slider",
  "valve" : "Valve",
  "number-shots" : "Number shots",
  "custom" : "Custom",
  "move-machine" : "Move machine",
  "machine-is-not-selected" : "Machine is not selected.",
  "machine-successfully-deleted" : "'Machine successfully deleted.'",
  "failed-to-delete-machine" : "Failed to delete machine.",
  "failed-to-backup-machine" : "Failed to backup machine.",
  "owner-successfully-changed" : "Owner successfully changed.",
  "failed-to-change-owner" : "Failed to change owner.",
  "machine-successfully-copied" : "Machine successfully copied.",
  "failed-to-copy-machine" : "Failed to copy machine.",
  "machine-successfully-moved" : "Machine successfully moved.",
  "failed-to-move-machine" : "Failed to move machine.",
  "machine-set-as-current" : "Machine set as current.",
  "install-app-question" : "Would you like to install 3U Vision Cloud app?",
  "install" : "Install",
  "cancel" : "Cancel",
  "install-application" : "Install application",
  "step" : "Step",
  "tap-share-icon" : "Tap the Share Icon.",
  "scroll-down-and-tap" : "In the share menu, scroll down and tap",
  "add-to-home-screen" : "Add to Home Screen",
  "you-will-be-propted" : "You will be prompted to name the app. You can keep the default name or change it as desired. Then, tap",
  "add" : "Add",
  "in-top-right-corner" : "in the top right corner",
  "do-not-show-again" : "Don't show again",
  "you-are-offline" : "You are offline.",
  "app-can-not-work-offline" : "The app can not work offline.",
  "please-check-your-internet-connection" : "Please check your internet connection.",
  "unexpected-server-version" : "Unexpected server version.",
  "current-is" : "Current is",
  "and-expected" : "and expected",
  "application-version-is" : "Application version is",
  "new-version-available" : "New version available",
  "do-you-want-to-install" : "Do you want to install?",
  "delete-confirmation" : "Delete confirmation",
  "machine-medium-remove-question" : "Are you sure you want to delete medium?",
  "machine-medium-checkout-error" : "Failed to checkout machine medium.",
  "invalid-data" : "Invalid data.",
  "failed-to-load-messages" : "Failed to load messages.",
  "failed-to-save-board" : "Failed to save board.",
  "failed-to-delete-board" : "Failed to delete board.",
  "machine-structure-caption": "Structure",
  "machine-structure-value-caption": "Value",
  "machine-structure-not-available" : "Machine structure is not available",
  "machines-upload-file-upload-in-progress": "File upload in progress.",
  "upload-success": "Upload successful.",
  "confirmation": "Confirmation",
  "start-machine-question" : "Are you sure you want to start this machine?",
  "operation-done": "Operation done.",
  "operation-failde": "Operation failed."
}
